// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SHOW_ALL_FRIENDS = "Uk\u00e1\u017e v\u0161etk\u00fdch";
